import { makePutRequest } from 'lib/axios';
import type { UserSession } from 'types';

/** Only include fields that the section can edit — never send the full profile. */
export type IUpdateProfilePayload = Partial<{
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  streetAddress: string;
  cityAddress: string;
  stateAddress: string;
  zipAddress: string;
  dob: Date | string;
  ethnicity: string;
  gradeLevel: string;
  schoolName: string;
  githubUsername: string;
}>;

const updateProfile = async (
  payload: IUpdateProfilePayload,
): Promise<UserSession> => {
  const url = `/profile/`;
  const response = await makePutRequest(url, payload);
  return response.data.payload;
};

export default updateProfile;
